import React from "react";

export default function Footer(){
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <h4>AVRNHH</h4>
          <p>Fast local deliveries • Fresh produce</p>
        </div>
        <div>
          <h4>Contact</h4>
          <p>help@avrnhh.online</p>
        </div>
        <div>
          <h4>Follow</h4>
          <p>Twitter • Facebook • Instagram</p>
        </div>
      </div>
      <div className="copyright">© {new Date().getFullYear()} avrnhh</div>
    </footer>
  );
}
